//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as moment from "moment";
import { useHistory } from "react-router-dom";

// custom pages
import { Styles } from "./styles";
import Context from "context/context";
import OverWriteApi from "apis/overwrite/overwrite";
import { toastCss, successCss } from "assets/styleJS/global";

// material-ui
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from 'react-i18next';
// material-ui icons
import DeleteIcon from "@material-ui/icons/Delete";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import { dateFormat } from "helpers/dataFormat"
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: "0px !important",
        marginTop: 0,
      },
      "&.MuiFormControl-marginNormal": {
        marginTop: "0px !important",
        marginBottom: "0px !important",
      },
      "& MuiSelect-outlined": {
        borderRadius: 0,
      },
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: "0px !important",
      marginTop: 0,
      backgroundColor: "#fff !important",
    },
    ".MuiDialog-paperWidthSm": {
      maxWidth: "none",
      // overFlow: "hidden",
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child':
    {
      paddingLeft: 20,
    },
    ".MuiFormLabel-root": {
      color: "black",
    },
    ".MuiTable-root": {
      marginBottom: "10px",
    },
  },
})(() => null);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);
  const { create, getReasonDescription } =
    OverWriteApi();
  const { setActiveTab } = props;
  const { t, i18n } = useTranslation();
  const classes = Styles();
  const history = useHistory();

  const [data, setData] = useState([{}, {}]);
  const [open, setOpen] = useState(false);
  const [newDialogOpen, setNewDialogOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [reasonCode, setResaonCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [reason, setReason] = useState("");

  const [isCustomReason, setIsCustomReason] = useState(false)
  useEffect(() => {
    handleGetReasonDescriptions();
    if (searchValue && searchValue.length > 0) {
      handleGetReasonDescriptions(searchValue);
    }
    sessionStorage.removeItem("error");
  }, [searchValue]);

  async function handleGetReasonDescriptions(searchValue) {
    try {
      let values = {};
      if (searchValue && searchValue.length > 0) {
        values = { ...values, searchValue };
      }
      let res = await getReasonDescription(values);
      if (res) {
        setResaonCode(res);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  useEffect(() => {
    setNewDialogOpen(true);
    setData([
      {
        customer_billto_account_number: "",
        points: "",
        reason_code: "",
        rule_description: "",
        date_of_transaction: moment().format("YYYY-MM-DD")
      },
    ]);
  }, []);

  const handleCreate = async () => {
    try {
      const keyToRemove = "reason_code_other"
      const updatedData = data.map(item => {
        //   if (item.id === idToRemove) {
        const { [keyToRemove]: removedKey, ...rest } = item;
        return { ...rest };
        //   }
        //   return item;
      });
      data.length = 0; // Clear the current array
      Array.prototype.push.apply(data, updatedData);
      let values = { data };
      setIsDisabled(true);
      let res = await create(values);
      setIsDisabled(false);
      if (res && res.type === "success") {
        setData([]);
        history.push("/dashboard/upload-success", {
          type: i18n.language == 'fr' ? res.french_message : res.message,
        });
      } else {
        toast.error(i18n.language == 'fr' ? res?.french_message : res.message, toastCss);
      }
    } catch (e) {
      console.log("errors");
    }
  };


  // points format func
  const pointFormat = (point) => {
    var nfObject = new Intl.NumberFormat("en-US");
    var res = nfObject.format(point);
    return res;
  };

  const headings = [
    "Billto Account Number",
    "Points to be Awarded",
    "Reason Code",
    "Customer facing Description",
  ];

  console.log(data, "this is the data")

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  const blockPointsInvalidChar = (e) =>
    ["e", "E", "+"].includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Dialog
        onClose={() => {
          setOpen(!open);
        }}
        aria-labelledby="simple-dialog-title"
        open={newDialogOpen}
        maxWidth='md'
      >
        <div style={{ padding: "50px 20px" }}>
          <Grid container spacing={0}>
            <span
              style={{
                position: "absolute",
                right: "2%",
                top: "1%",
                cursor: "pointer",
                fontSize: 20,
              }}
              onClick={() => setActiveTab(0)}
            >
              x
            </span>
            <Grid item xs={12} style={{ textAlign: "center", fontSize: 20 }}>
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {t('Insert Data for Points Adjustment')}
              </span>
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
            <Grid xs={12}>
              <TableContainer className={classes.tableContainer}>
                <Table>
                  <TableHead
                    style={{
                      background: "#EDEDED",
                    }}
                  >
                    <TableRow>
                      {headings.map((h, i) => (
                        <TableCell
                          key={i}
                          style={{
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 16,
                            fontFamily: "segoe-ui !important",
                            padding: 0,
                            border: "1px solid",
                            textAlign: "center",
                            width: 300,
                          }}
                        >
                          {t(h)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((item, index) => {
                      return (
                        <TableRow role="checkbox" tabIndex={-1} key={0}>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"number"}
              onWheel={(e) => e.target.blur()}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={
                                data[index]?.customer_billto_account_number
                              }
                              onKeyDown={blockInvalidChar}
                              onChange={(e) => {
                                let arr = [...data];
                                arr[index].customer_billto_account_number =
                                  e.target.value;
                                setData(arr);
                              }}
                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"text"}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={data[index]?.points}
                              onKeyDown={blockPointsInvalidChar}
                              onChange={(e) => {
                                let arr = [...data];
                                let value = e.target.value;
                                if (e.target.value === "") {
                                  arr[index].points = "";
                                  setData(arr);
                                  return;
                                }
                                value = value.replace(/\,/g, "");
                                if (value !== "-") {
                                  arr[index].points = pointFormat(
                                    parseInt(value)
                                  );
                                } else {
                                  arr[index].points = "-";
                                }
                                setData(arr);
                              }}
                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            {data[index]?.reason_code_other === "Others" ? (
                              <CssTextField
                                id="combo-box-demo"
                                type={"text"}
                                placeholder={t("Enter a reason")}
                                variant="outlined"
                                autoComplete="off"
                                //  className={classes.extendedInput}
                                value={data[index]?.reason_code}
                                onChange={(e) => {
                                  let arr = [...data];
                                  arr[index].reason_code = e.target.value;
                                  setData(arr);
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">

                                      <IconButton
                                        onClick={() => {
                                          let arr = [...data];
                                          arr[index].reason_code = "";
                                          arr[index].reason_code_other = "";
                                          setData(arr);
                                        }}
                                      >
                                        <ClearIcon />
                                      </IconButton>

                                    </InputAdornment>
                                  ),
                                }}
                              />
                            ) :
                              <Autocomplete
                                id="combo-box-demo"
                                autoSelect={true}
                                options={reasonCode}
                                inputValue={data[index].reason_code}
                                value={data[index].reason_code}
                                getOptionLabel={(o) => t(o.reason_description)}
                                filterOptions={(options, state) => options}
                                renderInput={(params) => (
                                  <CssTextField
                                    {...params}
                                    variant="outlined"
                                    value={searchValue}
                                    onChange={(e) => {
                                      setSearchValue(e.target.value);
                                    }}
                                  />
                                )}
                                onChange={(value, a, reason) => {
                                  if (reason === "clear") {
                                    let arr = [...data];
                                    arr[index].reason_code = "";
                                    arr[index].reason_code_other = "";

                                    setData(arr);
                                    setIsCustomReason(false)

                                    return;
                                  }
                                  if (a?.reason_description === "Others") {
                                    // setIsCustomReason(true)
                                    let arr = [...data];
                                    arr[index].reason_code = "";
                                    arr[index].reason_code_other = a?.reason_description
                                    setData(arr);
                                    return;
                                  }
                                  let arr = [...data];
                                  arr[index].reason_code = a?.reason_description;
                                  arr[index].reason_code_other = a?.reason_description;

                                  setData(arr);
                                }}
                              />
                            }

                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"text"}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={data[index]?.rule_description}
                              onChange={(e) => {
                                let arr = [...data];
                                arr[index].rule_description = e.target.value;
                                setData(arr);
                              }}
                            />
                          </TableCell>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {data.length > 1 && (
                              <DeleteIcon
                                style={{
                                  color: "red",
                                  cursor: "pointer",
                                  position: "relative",
                                  top: 10,
                                }}
                                onClick={() => {
                                  let arr = [...data];
                                  arr.splice(index, 1);
                                  setData(arr);
                                }}
                              />
                            )}
                            {data.length - 1 === index && (
                              <ControlPointIcon
                                style={{
                                  color: "green",
                                  cursor: "pointer",
                                  position: "relative",
                                  top: 10,
                                }}
                                onClick={() => {
                                  let condition = Object.values(data[index]).some(
                                    (i) => i === null || i?.length === 0
                                  );
                                  if (condition) {
                                    toast.error("Please fill all the fields.", {
                                      ...toastCss,
                                      autoClose: 5000,
                                    });
                                    return;
                                  }
                                  let arr = [...data];
                                  arr.push({
                                    customer_billto_account_number: "",
                                    points: "",
                                    reason_code: "",
                                    rule_description: "",
                                    date_of_transaction: moment().format("YYYY-MM-DD")
                                  });
                                  setData(arr);
                                }}
                              />
                            )}
                          </div>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  className={classes.popupCancelBtn}
                  onClick={() => setActiveTab(0)}
                >
                  {t('Cancel')}
                </button>
                <button
                  disabled={isDisabled}
                  className={classes.saveBtn}
                  onClick={() => {
                    let condition;
                    for (let i of data) {
                      condition = Object.values(i).some(
                        (j) => j === undefined || j === null || j.length === 0
                      );
                      if (condition) {
                        return toast.error(`${t('Please fill all the fields.')}`, {
                          ...toastCss,
                          autoClose: 5000,
                        });
                      }
                    }
                    if (!condition) {
                      let array = [...data];
                      for (let i of array) {
                        if (typeof i.points === "string")
                          i.points = parseInt(i.points.replace(/\,/g, ""));
                      }
                      setData(array);
                      handleCreate();
                    }
                  }}
                >
                  {t('Save')}
                </button>
                <button
                  className={classes.saveBtn}
                  style={{ position: "absolute", right: "5%" }}
                  onClick={() => {
                    setData([{
                      customer_billto_account_number: "",
                      points: "",
                      reason_code: "",
                      rule_description: "",
                      date_of_transaction: moment().format("YYYY-MM-DD")
                    }])
                  }}
                >
                  {t('Reset')}
                </button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
